(function (global, factory) {
  'use strict';
  var core = typeof module === 'object' && module.exports ? require('./events-manifest-core') : global.EventsManifestCore;
  var api = factory(core, global);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else global.EventsManifestRefresh = api;
}(typeof globalThis !== 'undefined' ? globalThis : this, function (core, runtime) {
  'use strict';

  var MAX_SERVER_SKEW_MS = 2 * 60 * 1000;
  var REFRESH_INTERVAL_MS = 60 * 1000;
  var REQUEST_TIMEOUT_MS = 10 * 1000;
  var TRANSPORT_SECTION_ID = 'events-manifest-data';
  var BACKOFF = [5000, 10000, 20000, 40000, 60000];

  function parseHtml(source, DOMParserClass) {
    if (typeof source !== 'string' || typeof DOMParserClass !== 'function') throw new Error('manifest response is not parseable');
    var document = new DOMParserClass().parseFromString(source, 'text/html');
    var roots = document.querySelectorAll('[data-events-manifest-response="' + TRANSPORT_SECTION_ID + '"]');
    var root = roots.length === 1 ? roots[0] : null;
    var nodes = root && root.querySelectorAll('[data-events-manifest]');
    var node = nodes && nodes.length === 1 ? nodes[0] : null;
    var epoch = root && Number(root.dataset.serverEpochMs);
    if (!root || !node || !Number.isFinite(epoch) || epoch <= 0) throw new Error('manifest section response is incomplete');
    return { raw: JSON.parse(node.textContent), serverEpochMs: epoch };
  }

  function create(options) {
    options = options || {};
    var fetchFn = options.fetch || runtime.fetch;
    if (typeof fetchFn !== 'function' || !core || typeof core.readEnvelope !== 'function') throw new Error('manifest refresh dependencies unavailable');
    var DOMParserClass = options.DOMParser || runtime.DOMParser;
    var setTimeoutFn = options.setTimeout || runtime.setTimeout;
    var clearTimeoutFn = options.clearTimeout || runtime.clearTimeout;
    var monotonicNow = options.monotonicNow || function () { return runtime.performance.now(); };
    var AbortControllerClass = options.AbortController || runtime.AbortController;
    var parse = options.parseResponse || function (body) { return parseHtml(body, DOMParserClass); };
    var requestedTimeout = options.requestTimeoutMs;
    var requestTimeoutMs = typeof requestedTimeout === 'number' && Number.isFinite(requestedTimeout) && requestedTimeout >= 1000 && requestedTimeout <= 30000 ? requestedTimeout : REQUEST_TIMEOUT_MS;
    var alive = true; var timer = null; var cancelPending = null; var requestRevision = 0; var failureCount = 0;
    var acceptedVersion = 0; var acceptedHash = null; var clockOrigin = null; var clockEpoch = null;
    var reusableAccepted = false; var acceptedRevocations = [];

    function now() {
      return clockOrigin === null ? NaN : clockEpoch + Math.max(0, monotonicNow() - clockOrigin);
    }
    function schedule(delay) {
      if (!alive) return;
      if (timer !== null) clearTimeoutFn(timer);
      timer = setTimeoutFn(refreshNow, delay);
    }
    function refreshError(code, message) { var error = new Error(message || code); error.eventsCode = code; return error; }
    function fail(error) {
      if (!alive) return;
      failureCount += 1;
      var delay = BACKOFF[Math.min(failureCount - 1, BACKOFF.length - 1)];
      schedule(delay);
      if (typeof options.onFailure === 'function') options.onFailure(error, now(), { code: error && error.eventsCode || 'refresh_failed', failureCount: failureCount, retryInMs: delay });
    }
    function endpoint() {
      var location = options.location || runtime.location;
      var origin = location && location.origin ? location.origin : 'https://events.invalid';
      var target = new URL(options.url, origin);
      if (target.origin !== origin) throw new Error('manifest refresh endpoint must be same-origin');
      target.searchParams.delete('sections');
      target.searchParams.delete('sections[]');
      target.searchParams.set('section_id', TRANSPORT_SECTION_ID);
      if (location && location.href) {
        var current = new URL(location.href);
        ['preview_theme_id', '_fd', 'pb'].forEach(function (key) {
          if (current.searchParams.has(key) && !target.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
        });
      }
      target.searchParams.set('_events_refresh', String(Date.now()) + '-' + requestRevision);
      return target.pathname + target.search;
    }
    function refreshNow() {
      if (!alive || typeof fetchFn !== 'function' || typeof options.url !== 'string' || !options.url) return Promise.resolve(false);
      if (timer !== null) { clearTimeoutFn(timer); timer = null; }
      requestRevision += 1;
      var revision = requestRevision;
      if (cancelPending) cancelPending();
      var requestAborter = typeof AbortControllerClass === 'function' ? new AbortControllerClass() : null;
      var url;
      try { url = endpoint(); }
      catch (error) { fail(error); return Promise.resolve(false); }
      var deadlineTimer = null; var rejectDeadline;
      var deadline = new Promise(function (_, reject) {
        rejectDeadline = reject;
        deadlineTimer = setTimeoutFn(function () {
          reject(refreshError('request_timeout', 'manifest refresh timed out'));
          if (requestAborter) requestAborter.abort();
        }, requestTimeoutMs);
      });
      function cleanup() {
        if (deadlineTimer !== null) clearTimeoutFn(deadlineTimer);
        deadlineTimer = null;
        if (cancelPending === cancel) cancelPending = null;
      }
      function cancel() {
        cleanup();
        rejectDeadline(refreshError('request_cancelled'));
        if (requestAborter) requestAborter.abort();
      }
      cancelPending = cancel;
      var request = Promise.resolve().then(function () {
        if (!alive || revision !== requestRevision) throw refreshError('request_cancelled');
        if (typeof options.onStart === 'function') options.onStart({ failureCount: failureCount, transport: 'section' });
        return fetchFn(url, {
          credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' },
          signal: requestAborter ? requestAborter.signal : undefined
        });
      }).then(function (response) {
        if (!response || !response.ok) throw refreshError('http_failure', 'manifest refresh HTTP failure');
        var dateHeader = response.headers && response.headers.get ? response.headers.get('Date') : null;
        var headerEpoch = dateHeader ? Date.parse(dateHeader) : NaN;
        if (!Number.isFinite(headerEpoch)) throw refreshError('server_time_missing', 'manifest refresh lacks trusted server time');
        return response.text().then(function (body) {
          if (!alive || revision !== requestRevision) throw refreshError('request_cancelled');
          try { return { parsed: parse(body), headerEpoch: headerEpoch }; }
          catch (_) { throw refreshError('response_invalid', 'manifest response is incomplete or invalid'); }
        });
      });
      return Promise.race([request, deadline]).then(function (result) {
        if (!alive || revision !== requestRevision) return false;
        if (typeof options.onResponse === 'function') {
          try { options.onResponse({ transport: 'section', renderedAtMs: result.parsed.serverEpochMs, responseDateMs: result.headerEpoch, skewMs: Math.abs(result.parsed.serverEpochMs - result.headerEpoch) }); }
          catch (_) { /* Diagnostics cannot authorize or prevent admission. */ }
        }
        if (!alive || revision !== requestRevision) return false;
        if (Math.abs(result.parsed.serverEpochMs - result.headerEpoch) > MAX_SERVER_SKEW_MS) throw refreshError('server_time_stale', 'manifest response is stale or inconsistently timed');
        var candidateOrigin = monotonicNow();
        var existingNow = clockOrigin === null ? NaN : clockEpoch + Math.max(0, candidateOrigin - clockOrigin);
        var candidateNow = Math.max(result.parsed.serverEpochMs, result.headerEpoch, Number.isFinite(existingNow) ? existingNow : -Infinity);
        var envelope = core.readEnvelope(result.parsed.raw, options.identity, candidateNow, options.maxAgeMs);
        if (!envelope.ok) throw refreshError('manifest_rejected', envelope.reason || 'manifest rejected');
        if (envelope.manifestVersion < acceptedVersion) throw refreshError('version_regression', 'manifest version regressed');
        if (envelope.manifestVersion === acceptedVersion && acceptedHash !== null && result.parsed.raw.contentHash !== acceptedHash) {
          throw refreshError('version_conflict', 'manifest version changed without advancing');
        }
        if (reusableAccepted && envelope.releaseMode !== 'supervised_publication') throw refreshError('mode_regression', 'reusable publication mode cannot regress');
        if (envelope.releaseMode === 'supervised_publication') {
          var nextRevocations = result.parsed.raw.revocations;
          if (acceptedRevocations.some(function(old){return !nextRevocations.some(function(next){return core.stableStringify(old)===core.stableStringify(next);});})) throw refreshError('revocation_regression', 'revocation history cannot regress');
          reusableAccepted = true; acceptedRevocations = JSON.parse(JSON.stringify(nextRevocations));
        }
        clockOrigin = candidateOrigin; clockEpoch = candidateNow;
        acceptedVersion = envelope.manifestVersion; acceptedHash = result.parsed.raw.contentHash; failureCount = 0;
        if (typeof options.onAccept === 'function') options.onAccept(envelope, now);
        schedule(REFRESH_INTERVAL_MS);
        return true;
      }).catch(function (error) {
        if (!alive || revision !== requestRevision || error && error.eventsCode === 'request_cancelled') return false;
        fail(error); return false;
      }).finally(cleanup);
    }
    function destroy() {
      if (!alive) return;
      alive = false; requestRevision += 1;
      if (timer !== null) clearTimeoutFn(timer);
      if (cancelPending) cancelPending();
      timer = null; cancelPending = null;
    }
    schedule(0);
    return { destroy: destroy, now: now, refreshNow: refreshNow };
  }

  return { create: create, parseHtml: parseHtml };
}));
